/* Read https://hello.atlassian.net/wiki/spaces/DQ/pages/786078865 on how to instrument well. */

// These are entities in ProForma. Reuse as much as possible.
// Think carefully when making a new ActionSubject about whether you can reuse an existing one.
export let ActionSubject = /*#__PURE__*/function (ActionSubject) {
  ActionSubject["FORM"] = "form";
  ActionSubject["FORM_SETTINGS_LANGUAGE"] = "formSettingsLanguage";
  ActionSubject["FORM_SETTINGS_SUBMIT"] = "formSettingsSubmit";
  ActionSubject["FORM_SETTINGS_ISSUE_CREATE"] = "formSettingsIssueCreate";
  ActionSubject["FORM_SETTINGS_ISSUE_FORMS_TYPES"] = "formSettingsIssueFormsTypes";
  ActionSubject["FORM_SETTINGS_RECOMMENDED_FORMS_TYPES"] = "formSettingsRecommendedFormsTypes";
  ActionSubject["FORM_SETTINGS_REQUEST_CREATE_TYPES"] = "formSettingsRequestCreateTypes";
  ActionSubject["QUESTION_ANSWER"] = "questionAnswer";
  ActionSubject["TEMPLATE_FORM"] = "templateForm";
  ActionSubject["EXAMPLE_TEMPLATE"] = "exampleTemplate";
  ActionSubject["BUTTON"] = "button";
  ActionSubject["DROPDOWN_ITEM"] = "dropdownItem";
  ActionSubject["SELECT_ITEM"] = "selectItem";
  ActionSubject["FILTER"] = "filter";
  ActionSubject["LIST"] = "list";
  ActionSubject["PANEL"] = "panel";
  ActionSubject["SECTION"] = "section";
  ActionSubject["TABLE"] = "table";
  ActionSubject["MODAL"] = "modal";
  ActionSubject["PROFORMA_API"] = "proformaAPI";
  ActionSubject["PROFORMA_UI"] = "proformaUI";
  ActionSubject["SECTION_MESSAGE"] = "sectionMessage";
  ActionSubject["ATTACHMENT"] = "proformaAttachment";
  ActionSubject["ATTACHMENT_UPLOAD"] = "proformaAttachmentUpload";
  ActionSubject["ATTACHMENT_VIEWER"] = "proformaAttachmentViewer";
  ActionSubject["ATTACHMENT_VIEWER_CARD"] = "proformaAttachmentViewerCard";
  ActionSubject["REQUEST_TYPE"] = "requestType";
  ActionSubject["DUPLICATE_REQUEST_TYPE_LINKED_FIELDS_WARNING_MODAL"] = "duplicateRequestTypeLinkedFieldsWarningModal";
  ActionSubject["TRANSLATIONS_EDITOR"] = "translationsEditor";
  ActionSubject["ADF_NODE_INSERT"] = "adfNodeInsert";
  ActionSubject["FORM_VALIDATION"] = "formValidation";
  ActionSubject["FORM_EDIT"] = "formEdit";
  ActionSubject["FORM_SAVE"] = "formSave";
  ActionSubject["SEARCH_ASYNC_CHOICES"] = "searchAsyncChoices";
  ActionSubject["FETCH_FORM_ATTACHMENTS"] = "fetchFormAttachments";
  ActionSubject["UPLOAD_ISSUE_FORM_ATTACHMENTS"] = "uploadFormAttachments";
  ActionSubject["TRANSLATIONS_LANGUAGES_LOAD"] = "translationsLoad";
  ActionSubject["TRANSLATIONS_LOAD"] = "translationsLoad";
  ActionSubject["TRANSLATIONS_SAVE"] = "translationsSave";
  ActionSubject["TRANSLATIONS_DELETE"] = "translationsDelete";
  return ActionSubject;
}({});

// Actions that can be performed on ActionSubjects. Try to use common ones from the list.
// See https://hello.atlassian.net/wiki/spaces/DQ/pages/1021070478
export let Action = /*#__PURE__*/function (Action) {
  Action["ADDED"] = "added";
  Action["CLICKED"] = "clicked";
  Action["CREATED"] = "created";
  Action["DELETED"] = "deleted";
  Action["DOWNLOADED"] = "downloaded";
  Action["EXPORTED"] = "exported";
  Action["UPDATED"] = "updated";
  Action["VIEWED"] = "viewed";
  Action["SELECTED"] = "selected";
  Action["FAILED"] = "failed";
  Action["FINISHED"] = "finished";
  Action["STARTED"] = "started";
  Action["STOPPED"] = "stopped";
  return Action;
}({});

// Mechanisms to update a Form.
export let FormUpdateType = /*#__PURE__*/function (FormUpdateType) {
  FormUpdateType["REOPEN"] = "REOPEN";
  FormUpdateType["SAVE"] = "SAVE";
  FormUpdateType["SET_EXTERNAL"] = "SET_EXTERNAL";
  FormUpdateType["SET_INTERNAL"] = "SET_INTERNAL";
  FormUpdateType["SUBMIT"] = "SUBMIT";
  FormUpdateType["CLOSE"] = "CLOSE";
  return FormUpdateType;
}({}); // Similar to SUBMIT, used in "Close customer edits" option in form card meatball menu